import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=0fefef7d&scoped=true&"
import script from "./PostsList.vue?vue&type=script&lang=js&"
export * from "./PostsList.vue?vue&type=script&lang=js&"
import style0 from "./PostsList.vue?vue&type=style&index=0&id=0fefef7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefef7d",
  null
  
)

export default component.exports